export default __webpack_public_path__ + "static/media/profile5.733faead.png";